import { render, staticRenderFns } from "./board.vue?vue&type=template&id=0f5de4d2&scoped=true&"
import script from "./board.vue?vue&type=script&lang=ts&"
export * from "./board.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5de4d2",
  null
  
)

export default component.exports